import React from 'react';
import { motion } from 'framer-motion';
import ProjectStatsBadge from '../../../components/ProjectStatsBadge';
import ShareProjectButton from '../../../components/ShareProjectButton/ShareProjectButton';
import './employee-daily-task-allocation-management-system.css';
import employeeTaskImg from '../../../assets/images/employeedailytask .jpeg';

const EmployeeDailyTaskAllocationManagementSystem = () => {
  return (
    <motion.div 
      className="project-detail-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <motion.h1 
        className="project-heading"
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        Employee <span>Daily Task Allocation</span> Management System
      </motion.h1>

      <motion.p 
        className="last-updated"
        initial={{ x: 50, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.4 }}
      ><br />
        Last Updated On: 10th December 2024
      </motion.p>

      <div className="project-content">
        <motion.div 
          className="project-left"
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <img src={employeeTaskImg} alt="Employee Daily Task Allocation" className="project-image" />
          <h2 className="project-subtitle">Employee Daily Task Allocation Management System</h2>
          <span className="project-category">Software</span>
          <p className="project-author">Author: Praveen Kumar B</p>

          <ProjectStatsBadge docId="employeeTaskManager" trackView={true} />

          {/* Buttons */}
          <div className="project-buttons">
            <a href="/under-construction" className="visit-project-button">
              → Visit the Project
            </a>
            <a href="https://github.com/Praveenkumar-king/Employee-Daily-Task-Allocation-Management-System" className="visit-project-button">
              → View on GitHub
            </a>
            <ShareProjectButton
              project={{
                id: "employeeTaskManager",
                title: "Employee Daily Task Allocation Management System",
                path: "/projects/projectdetail/employee-daily-task-allocation-management-system"
              }}
            />
          </div>
        </motion.div>

        <motion.div 
          className="project-right"
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          <h3 className="section-title">Project Details</h3>
          <p className="overview-text">
            Hi Friends & Family 🎉🎉, Here's The Detailed Explanation Of The Project.
          </p>

          <h3 className="section-title">Overview ✨</h3>
          <p className="overview-description">
            The <strong>Employee Daily Task Allocation Management System</strong> is a comprehensive software solution to optimize task assignment, tracking, and management within an organization. It bridges communication gaps, fosters collaboration, and ensures clarity in task delegation. 📋✅
          </p>

          <h3 className="section-title">Key Features 🛠️</h3>
          <ul className="feature-list">
            <li>Task Assignment 📋 - Categorize tasks by priority and set clear deadlines.</li>
            <li>Employee Dashboard 📢👥 - Personalized dashboards for tracking responsibilities.</li>
            <li>Real-Time Updates 🔔 - Notifications for updates and approaching deadlines.</li>
            <li>Performance Tracking 📊 - Detailed reports on task progress and employee efficiency.</li>
            <li>Collaborative Tools 🔗 - Integrated communication and file-sharing features.</li>
            <li>Customizable Task Templates 🖋️ - Save time with reusable task templates.</li>
            <li>Mobile Access 📱 - Fully responsive and accessible on all devices.</li>
            <li>Integration Capabilities 🔗 - Sync with popular tools like Slack or Google Workspace.</li>
            <li>Advanced Reporting 📈 - Generate detailed insights and analytics.</li>
          </ul>

          <h3 className="section-title">Benefits 🌈</h3>
          <ul className="benefits-list">
            <li><strong>Enhanced Productivity</strong> 🧠 - Clear task assignments improve focus.</li>
            <li><strong>Time Management</strong> ⏰ - Notifications ensure timely task completion.</li>
            <li><strong>Transparency</strong> 🪞 - Real-time progress tracking builds trust.</li>
            <li><strong>Better Communication</strong> 🔗 - Integrated tools reduce communication gaps.</li>
            <li><strong>Scalability</strong> 🚀 - Supports businesses of all sizes.</li>
          </ul>

          <h3 className="section-title">How It Works 🔍</h3>
          <ul className="how-it-works-list">
            <li>Admin Setup ⚙️ - Define roles and permissions.</li>
            <li>Task Allocation 🗂️ - Assign and prioritize tasks.</li>
            <li>Employee Workflow 👩‍💻 - Employees update progress and manage tasks.</li>
            <li>Reporting 📈 - Managers monitor and analyze data.</li>
            <li>Feedback & Updates 💬 - Employees provide feedback for improvements.</li>
          </ul>

          <h3 className="section-title">Why Choose This System? 🤔</h3>
          <ul className="how-it-works-list">
            <li>User-Friendly Interface 🎨 - Clean and intuitive design.</li>
            <li>Cost-Effective 💵 - Reduces manual overhead.</li>
            <li>Data Security 🔒 - Robust encryption protects data.</li>
            <li>Customizable and Flexible 🔧 - Tailored workflows for business needs.</li>
            <li>24/7 Support 🛠️ - Dedicated support for assistance.</li>
          </ul>

          <h3 className="section-title">Conclusion 🎯</h3>
          <p>
            The <strong>Employee Daily Task Allocation Management System</strong> empowers teams to achieve more with less effort. 🚀 Its robust features, ease of use, and scalability make it an indispensable tool for businesses aiming for operational excellence. 🌟
          </p>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default EmployeeDailyTaskAllocationManagementSystem;
